module.exports = __webpack_public_path__ + "img/account.af92563e.svg";